import { Notification } from '@/features/notification/model/notification'
import { TranslationBundles } from '@/features/sitecore/configs/translation-bundles'
import { useSitecoreState } from '@/features/sitecore/store/useSitecoreState'
import { useGoogleAnalytics } from '@/utils/hooks/useGoogleAnalitics'
import { NotificationBadge } from '../uiComponents'

export interface NotificationTabButtonProps {
	type: string
	notifications: Notification[]
	isActive: boolean
}

export const NotificationTabButton = (props: NotificationTabButtonProps) => {
	const sitecoreStore = useSitecoreState((state) => state)
	const { pushLabelClickedEvent } = useGoogleAnalytics()

	const tabLabel = sitecoreStore.getLabel(TranslationBundles.NOTIFICATIONS, `NOTIFICATION-TAB-${props.type.toUpperCase()}`, props.type.toUpperCase())
	const notReadNotifications = props.notifications.filter((notification) => !notification.isRead)

	const sendPrivateNotificationGA4Event = () => {
		pushLabelClickedEvent({ event: 'privatenotification', eventName: 'private_notification', label_clicked: props.type, cta_clicked: props.type, section: props.type })
	}

	return (
		<div onClick={sendPrivateNotificationGA4Event} className="flex gap-1 h-[24px] items-center">
			{tabLabel}{' '}
			<NotificationBadge position="near" color={props.isActive ? 'primary' : 'secondary'}>
				{notReadNotifications.length}
			</NotificationBadge>
		</div>
	)
}
